import React, { createContext, useContext, useEffect, useState } from 'react'
import { View, ScrollView, Text, TouchableOpacity, Image, Dimensions, Platform } from 'react-native'
import { FlashList } from '@shopify/flash-list'
import styles from './TriviaListStyles'
import theme from '../../../theme'
import { Loader } from '../customUtils/Components/Loader'
import { getLanguage } from '../appBar/context/LocalizationContext'
import { placeholderGeneral } from '../customUtils/Constants'
import { AntDesign, Feather } from '@expo/vector-icons'
import { useNavigation } from '../../hooks/useWebNavigation'
import { useIsMobile } from '@/redux/zustand/useDimensionStore'
const isWeb = Platform.OS === 'web'
export const TriviaList = ({ points, trivias }) => {
    const { languageFile } = getLanguage()
    const modalImage = require('../../../assets/trivia/noTriviaWeb.png')
    if (trivias.length === 0) {
        return (
            <View style={[styles.containerNoTrivia, isWeb && { marginTop: 32 }]}>
                <Image source={modalImage} style={styles.imageNoTrivia} />
                <Text style={styles.title2}>{languageFile.no_trivia_available_title}</Text>
                <Text style={styles.description2}>{languageFile.no_trivia_text}</Text>
                <Text style={styles.description3}>{languageFile.no_trivia_text2}</Text>
            </View>
        )
    }
    return (
        <ScrollView>
            <View style={styles.containerSection}>{/* <Text style={styles.section}>Seleccione una categoría para comenzar:</Text> */}</View>
            {trivias.length > 0 && trivias.sort((a, b) => a.index - b.index).map((trivia, index) => <TriviaItem key={index} item={trivia} />)}
        </ScrollView>
    )
}
const TriviaItem = ({ item }) => {
    const { languageFile } = getLanguage()
    const navigation = useNavigation()
    const [image, setImage] = useState(item.image ? item.image : placeholderGeneral)
    const goToGame = () => {
        if (item.user_status_game === 1 || item.user_status_game === 3 || item.user_status_game === 4) {
            console.log('[TriviaList] Trivia no disponible, status:', item.user_status_game)
            return
        }
        console.log('[TriviaList] Navegando a TriviaGame con:', { name: item.name, id: item._id })
        navigation.navigate('TriviaGame', { game: item })
    }
    const isMobile = useIsMobile()

    return (
        <View style={{ flex: 1 }}>
            <TouchableOpacity style={styles.triviaItem} onPress={() => goToGame()}>
                <View style={{ flexDirection: 'row', alignItems: 'center', flex: 1 }}>
                    <Image
                        style={styles.triviaImage}
                        source={{ uri: image }}
                        onError={() => {
                            setImage(placeholderGeneral)
                        }}
                    />
                    <View style={{ flex: 1 }}>
                        {item.name && <Text style={[styles.triviaName, !isMobile && { fontSize: 16 }]}>{item.name}</Text>}
                        {item.description && <Text style={[styles.triviaDescription, !isMobile && { fontSize: 16 }]}>{item.description}</Text>}
                        <TriviaItemStatus status={item.user_status_game} languageFile={languageFile} />
                    </View>
                </View>
                <View style={styles.justifyCenter}>
                    <Feather name='chevron-right' size={20} color={theme.colors.colorPending} />
                </View>
            </TouchableOpacity>
            <View style={styles.dividerHorizontalLine}></View>
        </View>
    )
}
const TriviaItemStatus = ({ status }) => {
    const { languageFile } = getLanguage()
    let statusInfo = setStatusInfo(status)
    const isMobile = useIsMobile()
    function setStatusInfo(status) {
        switch (status) {
            case 1:
                return { color: theme.colors.colorApproved, text: languageFile.complete }
            case 2:
                return { color: theme.colors.colorApproved, text: languageFile.complete, extra: languageFile.play_again }
            case 3:
                return { color: theme.colors.colorApproved, text: languageFile.complete, extra: languageFile.tomorrow_again }
            case 4:
                return { color: theme.colors.mediumGray, text: 'Finalizada' }
            default:
                return { color: theme.colors.darkGray, text: languageFile.pending }
        }
    }
    if (status === 4) {
        return (
            <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                <Text
                    style={[
                        styles.status,
                        {
                            color: statusInfo.color,
                            borderColor: statusInfo.color,
                            borderWidth: 1,
                            backgroundColor: 'white',
                            paddingHorizontal: 10,
                            alignSelf: 'flex-start',
                        },
                        !isMobile && { fontSize: 14 },
                    ]}
                >
                    {statusInfo.text}
                </Text>
                {statusInfo.extra && (
                    <Text style={{ marginHorizontal: 15, color: theme.colors.colorPrimary, fontWeight: 'bold' }}>{statusInfo.extra}</Text>
                )}
            </View>
        )
    }
    return (
        <View style={{ flexDirection: 'row', alignItems: 'center' }}>
            <Text
                style={[
                    styles.status,
                    {
                        color: 'white',
                        borderColor: statusInfo.color,
                        backgroundColor: statusInfo.color,
                        paddingHorizontal: 10,
                        alignSelf: 'flex-start',
                    },
                    !isMobile && { fontSize: 14 },
                ]}
            >
                {statusInfo.text}
            </Text>
            {statusInfo.extra && (
                <Text style={{ marginHorizontal: 15, color: theme.colors.colorPrimary, fontWeight: 'bold' }}>{statusInfo.extra}</Text>
            )}
        </View>
    )
}
